import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/profile/users/dashboard",
		component: lazy(() => import("./UsersDashboardPage")),
	},
]);
